import { render, staticRenderFns } from "./AddAirTicketAllowance.vue?vue&type=template&id=8a7efc30"
import script from "./AddAirTicketAllowance.vue?vue&type=script&lang=js"
export * from "./AddAirTicketAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports